import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759bca7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "confirmed-insight-value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!

  return (_ctx.disabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.inputValue), 1))
    : (_openBlock(), _createBlock(_component_k_input, {
        key: 1,
        modelValue: _ctx.inputValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        onFocus: _ctx.handleFocus,
        onInput: _ctx.handleChange,
        onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        disabled: _ctx.disabled,
        type: _ctx.insight.controller.inputType,
        min: _ctx.calculateMin,
        max: _ctx.insight.controller.max,
        step: _ctx.insight.controller.step,
        ref: "input",
        class: "text-input"
      }, null, 8, ["modelValue", "onFocus", "onInput", "disabled", "type", "min", "max", "step"]))
}